export const totalRecordDetailConstants = {
    GET_SUCCESS: 'GET_TOTAL_RECORD_DETAIL_SUCCESS',
    DELETE_SUCCESS: 'DELETE_DEPARTMENT_SUCCESS',
    DELETE_FAILURE: 'DELETE_DEPARTMENT_FAILURE'
};
